import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
/** @jsxImportSource react */
import { useState } from "react";
import { Box, Text, useApp, useInput } from "ink";
import { Plan } from "./Plan.js";
export function ApprovePlan(props) {
    const { plan, approve } = props;
    const [selected, setSelected] = useState(0);
    const { exit } = useApp();
    useInput((_input, key) => {
        if (key.leftArrow || key.rightArrow) {
            setSelected((prev) => (prev === 0 ? 1 : 0));
        }
        else if (key.return) {
            approve(selected === 0);
            exit();
        }
    });
    return (_jsxs(Box, { flexDirection: "column", children: [_jsx(Plan, { plan: plan }), _jsx(Box, { marginTop: 1, children: _jsx(Text, { children: "Proceed?" }) }), _jsxs(Box, { gap: 1, children: [_jsxs(Text, { color: selected === 0 ? "green" : "gray", children: [selected === 0 ? "◉" : "○", " Yes"] }), _jsxs(Text, { color: selected === 1 ? "red" : "gray", children: [selected === 1 ? "◉" : "○", " No"] })] })] }));
}
//# sourceMappingURL=ApprovePlan.js.map